export const detectDevice = (): boolean => {
  if (!window) return null;

  return Boolean(
    window.navigator.userAgent.match(/Android|BlackBerry|iPhone|Opera Mini|IEMobile|WPDesktop/i)
  );
};

export const getApiLanguageValue = (locale: string): string => {
  return locale.substring(0, locale.indexOf('-'));
};

export const getLanguageBrowser = (): string => {
  const { language } = window.navigator;
  if (language === 'vi') {
    return `${language}-VN`;
  }

  if (language === 'en') {
    return `${language}-US`;
  }

  if (language === 'en-US') {
    return language;
  }

  return 'vi-VN';
};
